import React from "react";

import { ModalTypes } from "@/@types/common";
import { useI18n } from "@/utils/rioti18n";
import { ButtonWrapper, MessageWrapper } from "./errorModalStyles";

export type PropTypes = {
  modal: ModalTypes;
  closeModal: () => void;
};

export const ErrorModal = ({ modal, closeModal }: PropTypes) => {
  const { t } = useI18n();

  // Conditionally show the player support link for these modal that require it
  const psLinkEnabled = [
    ModalTypes.UNAUTHORIZED,
    ModalTypes.PURCHASE_FAILED,
    ModalTypes.UNSUPPORTED_REGION,
    ModalTypes.SERVER_ERROR,
  ].includes(modal);

  const subtitleEnabled = [ModalTypes.UNAUTHORIZED, ModalTypes.UNSUPPORTED_REGION, ModalTypes.SERVER_ERROR].includes(
    modal,
  );

  return (
    <>
      <MessageWrapper>
        <h1>{t(`dbuy.modal.${modal}.title`)}</h1>
        {subtitleEnabled && <p>{t(`dbuy.modal.${modal}.subtitle`)}</p>}
        <p>{t(`dbuy.modal.${modal}.message`)}</p>
      </MessageWrapper>
      <ButtonWrapper>
        {psLinkEnabled && (
          <a href={t(`dbuy.player_support.link`)}>
            <div className="modal-btn-secondary">{t(`dbuy.player_support.title`)}</div>
          </a>
        )}
        <div className="modal-btn" data-testid="modal-btn" onClick={() => closeModal()}>
          {t(`dbuy.modal.btn.ok`)}
        </div>
      </ButtonWrapper>
    </>
  );
};
